import {
  CreditRating,
  CrmType,
  FNIType,
  InventoryType,
  PriceRuleSource,
  TradeInType,
} from '@upstart/harmony/lib/constants';
import { DMSType } from '@upstart/harmony/lib/legos/dmsTypes';

export const BRANDS = [
  'Acura',
  'Alfa Romeo',
  'Aston Martin',
  'Audi',
  'Bentley',
  'BMW',
  'Buick',
  'Cadillac',
  'Chevrolet',
  'Chrysler',
  'Dodge',
  'Ferrari',
  'FIAT',
  'Ford',
  'Freightliner',
  'GMC',
  'Honda',
  'Hyundai',
  'INFINITI',
  'Jaguar',
  'Jeep',
  'Kia',
  'Lamborghini',
  'Land Rover',
  'Lexus',
  'Lincoln',
  'Maserati',
  'MAZDA',
  'McLaren',
  'Mercedes-Benz',
  'MINI',
  'Mitsubishi',
  'Nissan',
  'Porsche',
  'Ram',
  'Rolls-Royce',
  'Scion',
  'smart',
  'Subaru',
  'Tesla',
  'Toyota',
  'Volkswagen',
  'Volvo',
];

export const DAY_LIST = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
] as const;

export const PICKUP_OR_DELIVERY = {
  PICKUP: 'pickup',
  DELIVERY: 'delivery',
};

export const INVENTORY_TYPE_NAME: Record<InventoryType, string> = {
  [InventoryType.OTHER]: 'Other',
  [InventoryType.AUTOJINI]: 'AutoJini',
  [InventoryType.AUTOUPLINKTECH]: 'AutoUpLink Tech',
  [InventoryType.DEALERCARSEARCH]: 'Dealer Car Search',
  [InventoryType.DEALERDOTCOM]: 'Dealer.com',
  [InventoryType.DEALERINSPIRE]: 'Dealer Inspire',
  [InventoryType.DEALERSOCKET]: 'DealerSocket',
  [InventoryType.DEALERTRACK]: 'Dealertrack',
  [InventoryType.DEALERVISION]: 'Dealer Vision',
  [InventoryType.EBIZAUTOS]: 'eBizAutos',
  [InventoryType.ELEAD]: 'Elead',
  [InventoryType.FUSIONZONE]: 'fusionZONE',
  [InventoryType.HOMENETAUTO]: 'HomeNet Automotive',
  [InventoryType.INVENTORYPLUS]: 'Inventory+',
  [InventoryType.MAXDIGITAL]: 'MAX Digital',
  [InventoryType.PIX]: 'PIX',
  [InventoryType.VAUTO]: 'vAuto',
};

export const CRM_TYPE_NAME: Record<CrmType, string> = {
  [CrmType.DEALERSOCKET]: 'DealerSocket',
  [CrmType.DGDG_SALESFORCE]: 'DGDG Salesforce',
  [CrmType.ELEAD]: 'Elead',
  [CrmType.HIGHERGEAR]: 'HigherGear',
  [CrmType.REYNOLDS]: 'Reynolds and Reynolds',
  [CrmType.VINSOLUTIONS]: 'VinSolutions',
  [CrmType.STANDALONE]: 'Other',
};

export const FNI_TYPE_NAME: Record<FNIType, string> = {
  [FNIType.CUDL]: 'CUDL',
  [FNIType.DEALERTRACK]: 'Dealertrack',
  [FNIType.ROUTEONE]: 'RouteOne',
};

export const TRADEIN_MANAGER_TYPE_NAME: Record<TradeInType, string> = {
  [TradeInType.FIRSTLOOK]: 'FirstLook',
  [TradeInType.VAUTO]: 'vAuto',
};

export const DMS_TYPE_NAME: Record<DMSType, string> = {
  [DMSType.CDK]: 'CDK',
  [DMSType.DT]: 'Dealertrack',
  [DMSType.REYNOLDS]: 'Reynolds & Reynolds',
  [DMSType.STANDALONE]: 'Other',
  [DMSType.TEKION]: 'Tekion',
};

export const PRICE_SOURCE_NAME: { [index in PriceRuleSource]: string } = {
  [PriceRuleSource.FEED_PRICE]: 'Internet',
  [PriceRuleSource.INVOICE]: 'Invoice',
  [PriceRuleSource.MSRP]: 'Manufacturer Suggested Retail Price (MSRP)',
};

export const CREDIT_RATINGS_SORTED = [
  CreditRating.EXCELLENT,
  CreditRating.GOOD,
  CreditRating.AVERAGE,
  CreditRating.POOR,
];

export const CREDIT_RATING_NAME: { [index in CreditRating]: string } = {
  [CreditRating.EXCELLENT]: 'Excellent',
  [CreditRating.GOOD]: 'Good',
  [CreditRating.AVERAGE]: 'Average',
  [CreditRating.POOR]: 'Below Average',
};

export const BASIS_POINTS_TO_MONEY_FACTOR = 0.00001;

// Basically used to handle maximum decimal places
export const BASIS_POINTS_DECIMAL_PLACE_FACTOR = 100000000;

export enum LendingStatus {
  Enabled,
  StateDisabled,
  Disabled,
}

export const EXPIRED_SKIP_MFA_DATE = 'December 1, 2022';
